/* =============================================================================
 * M.M.LaFleur — responsive nav relocation.
 *
 * A theme block renders exactly once, so the mobile drawer cannot re-render
 * the nav in different markup the way the old flat section could. Instead
 * there is a single <nav data-mm-nav> which lives in the header bar on
 * desktop and inside the drawer below the breakpoint.
 *
 * Moving the element rather than cloning it keeps one set of block ids, so
 * the theme editor's click-to-select still resolves, and no listener has to
 * be rebound — every handler in the header script is delegated from document.
 *
 * The drawer itself is relocated to <body> by mm-nav-drawer.js, so the slot
 * is looked up fresh on each run rather than cached.
 * ========================================================================== */

(function () {
  "use strict";

  var BREAKPOINT = "(min-width: 1024px)";
  var pending = null;

  function place() {
    pending = null;

    var nav = document.querySelector("[data-mm-nav]");
    if (!nav) return;

    if (window.matchMedia(BREAKPOINT).matches) {
      var bar = document.querySelector(".mm-header-in");
      if (!bar) return;
      if (nav.parentElement === bar) return;
      /* Belongs between the logo and the actions. */
      var actions = bar.querySelector(".mm-header-actions");
      if (actions) {
        bar.insertBefore(nav, actions);
      } else {
        bar.appendChild(nav);
      }
      return;
    }

    var slot = document.querySelector("[data-mm-nav-slot]");
    if (!slot) return;
    if (nav.parentElement === slot) return;
    slot.appendChild(nav);
  }

  function schedule() {
    if (pending) return;
    pending = window.requestAnimationFrame(place);
  }

  place();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", place);
  }
  window.addEventListener("load", place);
  window.addEventListener("resize", schedule, { passive: true });

  /* The theme editor re-renders the header section on every settings change,
     and mm-nav-drawer.js moves the drawer to <body> after this first runs. */
  document.addEventListener("shopify:section:load", schedule);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}());
